import { RenderExpandableSectionOptions } from './types'
import InvalidConfiguration from './components/InvalidConfiguration'
import { Descriptions, Space } from 'antd'
import CIMSBasicFields from '../../../../../../CIMSBasicFields'
import Comments from './components/Comments'
import CustomFieldViewer from '../../../../../../CustomFields/CustomFieldViewer'
import { useCIMSTableContext } from '../../../..'
import { WithRecord } from '../../../../../types'

export function ExpandableSection<T extends object>({
  additionalInfo,
  comments,
  custom,
  customFields,
  record,
}: RenderExpandableSectionOptions<T> & WithRecord<T>) {
  const { rowKey } = useCIMSTableContext<T>()
  const key =
    typeof rowKey === 'function' ? rowKey(record) : String(record[rowKey])
  if (!additionalInfo && !comments && !custom && !customFields)
    return <InvalidConfiguration />
  return (
    <Space key={`expandable-section-${key}`} size="middle" direction="vertical">
      {additionalInfo && (
        <CIMSBasicFields
          key={`additional-info-${key}`}
          title={'Additional Info'}
          fields={additionalInfo}
        />
      )}
      {customFields && (
        <CustomFieldViewer
          key={`custom-field-viewer-${key}`}
          {...customFields}
        />
      )}
      {custom &&
        custom
          .filter(({ hidden }) => !hidden)
          .map((custom, i) => {
            if (custom.type === 'fields') {
              const { type: _, hidden: __, ...rest } = custom
              return (
                <CIMSBasicFields key={`custom-fields-type-${key}`} {...rest} />
              )
            }
            const { label, children } = custom
            return (
              <Descriptions
                key={`custom-expandable-section-${key}-${label ?? i}`}
                size="small"
                column={1}
                title={label}
              >
                <Descriptions.Item>{children}</Descriptions.Item>
              </Descriptions>
            )
          })}
      {comments && <Comments {...comments} record={record} />}
    </Space>
  )
}
